export const hiringCompanySettingsTabs = [
  {
    name: "Personal Details",
    path: "/settings/account/personal-details",
  },
  {
    name: "Username",
    path: "/settings/account/username",
  },
  {
    name: "Change Password",
    path: "/settings/account/change-password",
  },
];
